












import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons'
import { defineComponent } from '@vue/composition-api'
import colorScheme from '../../colorScheme'

export default defineComponent({
  name: 'SvgEye',
  components: {
    FontAwesomeIcon
  },
  props: {
    open: {
      type: Boolean,
      default: true
    },
    eyeColor: {
      type: String,
      default: 'white'
    }
  },
  setup() {
    return {
      colorScheme,
      eyeIcon: faEye,
      eyeSlashIcon: faEyeSlash
    }
  }
})
